module.exports = __webpack_public_path__ + "img/tips-responsible-icon.fe13755a.svg";